import React from 'react';
import { filterClickHandler, fireFilterEvent, topicFilter } from './common';
import { FilterListDiv } from './styled';

export default function TopicFilterList({
  mutate,
  setShowLoader,
  selectedFilter,
}) {
  return (
    <>
      {topicFilter?.map((data, index) => {
        return (
          <FilterListDiv key={index}>
            <input
              type="radio"
              id={`${data?.key}${index}`}
              name="topicListing"
              defaultChecked={selectedFilter == data?.key}
              onChange={() => {
                (filterClickHandler(data?.key, mutate, setShowLoader),
                  fireFilterEvent(data?.name));
              }}
              className="custom_radio"
            />
            <label htmlFor={`${data?.key}${index}`} className="custom_label">
              {data?.name}
            </label>
          </FilterListDiv>
        );
      })}
    </>
  );
}
